import { trackEvent } from '@didi/webx-js'

const ensureWindowLoaded = () =>
  new Promise(resolve => {
    // 检查 document.readyState 是否为 'complete'
    // 'complete' 表示整个页面（包括所有依赖资源如样式表、脚本、图片等）都已加载完成。
    // 这与 window.onload 事件触发的时机是一致的。
    if (document.readyState === 'complete') {
      // 如果页面已经加载完成，立即 resolve
      console.log('Window already loaded. Resolving immediately.')
      resolve()
    } else {
      // 如果页面尚未加载完成，添加 'load' 事件监听器
      console.log("Window not yet loaded. Waiting for 'load' event.")
      window.addEventListener(
        'load',
        () => {
          console.log("'load' event fired. Resolving.")
          resolve()
        },
        { once: true }
      ) // 使用 { once: true } 确保监听器只执行一次然后自动移除
    }
  })

export const preloadTrack = async () => {
  try {
    const pageDomTime = performance.now()
    await ensureWindowLoaded()
    window.setTimeout(() => {
      try {
        const jsFiles = window.performance.getEntries().filter(entry => {
          return (
            entry.entryType === 'resource' &&
            (entry.name.indexOf('quartz-mall/static/mall/js/vendor') > -1 ||
              entry.name.indexOf('quartz-mall/static/mall/js/common') > -1 ||
              entry.name.indexOf('quartz-mall/static/mall/js/index') > -1)
          )
        })
        if (jsFiles.length) {
          const jsLoadTime = Math.max(
            ...jsFiles.map(entry => entry.responseEnd)
          )
          const offlineMode = window.FKConfig?.getOffMode?.() ?? '-1' // 0-没命中阿波罗；1-命中离线包资源>1；2-没命中离线包资源
          const preLoadMode =
            window.FKConfig?.getUrlPreloadMode?.() ??
            window.FKConfig?.getPreloadMode?.() ??
            '-1' // 0-没命中阿波罗；1-开始preload；2-完成preload; 3-preload-超时
          const preloadHitResult =
            window.FKConfig?.getPreloadHitResult?.() ?? ''
          const preloadMissResult =
            window.FKConfig?.getPreloadMissResult?.() ?? ''
          const preloadStatus = window.FKConfig?.getPreloadStatus?.() ?? '-1' // 0-没命中阿波罗；1-开始preload；2-完成preload; 3-preload-超时
          trackEvent(
            'pub_wyc_warmup_mvp_resource_get_bt',
            '预热MVP资源缓存成功',
            {
              url: window.location.href,
              js_ready: jsLoadTime,
              offline_mode: offlineMode,
              preload_mode: preLoadMode,
              page_dom_time: pageDomTime,
              preload_hit_result: JSON.stringify(preloadHitResult),
              preload_miss_result: JSON.stringify(preloadMissResult),
              preload_status: JSON.stringify(preloadStatus),
            }
          )
        }
      } catch (_) {}
    }, 1000)
  } catch (_) {}
}
